import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import { Bug, CalendarDays } from 'lucide-react'
import { PHOTO_REFERENCES } from '../api'
import { referenceHref } from '../lib/references'
import type { PhotoReference } from '../types'
import PhotoReferencesSkeleton from './PhotoReferencesSkeleton'

interface Props {
  projectId: string
  photoId: string
}

const PhotoReferences: React.FC<Props> = ({ projectId, photoId }) => {
  const { t } = useTranslation()
  const { data, loading } = useQuery<{ photo: { references: PhotoReference[] } | null }>(PHOTO_REFERENCES, {
    variables: { id: photoId },
    fetchPolicy: 'cache-and-network',
  })
  const references = data?.photo?.references

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold">{t('Photos_references')}</h3>
      {!references && loading ? (
        <PhotoReferencesSkeleton />
      ) : !references || references.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('Photos_references_none')}</p>
      ) : (
        <ul className="space-y-1.5">
          {references.map((r) => (
            <li key={`${r.kind}-${r.id}`}>
              <Link to={referenceHref(projectId, r)} className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline">
                {r.kind === 'SNAG' ? <Bug className="h-3.5 w-3.5 shrink-0" /> : <CalendarDays className="h-3.5 w-3.5 shrink-0" />}
                <span className="break-words">{r.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default PhotoReferences
